
export const addRoll = (count) => ({
  type: 'ADD_ROLL',
  count
});

export const makeCharacterChoice = (choice) => ({
  type: 'CHARACTER_CHOICE',
  choice
});


/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/